import { MouseEventHandler } from 'react'
import { useTranslation } from 'react-i18next'

import { ROUTE_PATH } from 'lib/paths'
import { Group } from 'lib/_types'

import { Link } from 'features/i18n/router'

import Badge from 'components/Badge'

import './style.scss'

export const GroupName = ({
  group,
  ...other
}: {
  group: Group
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) => {
  const { t } = useTranslation()

  return (
    <Link to={ROUTE_PATH.GROUP(group?.id)} {...other} className="GroupName">
      {group?.topic}
      {group?.title && group?.title !== 'other' && (
        <Badge
          label={
            group?.title === 'admin'
              ? t('group.title.admin')
              : t('group.title.official')
          }
          theme={group?.title}
        />
      )}
    </Link>
  )
}
